import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./components/auth/msalInstance";

const root = ReactDOM.createRoot(document.getElementById("root"));

async function startApp() {
  try {
    // Inicializar MSAL (obligatorio en versión 3.x+)
    await msalInstance.initialize();

    // Procesar redirect si viene de login
    await msalInstance.handleRedirectPromise();

    // Renderizar la app
    root.render(
      <React.StrictMode>
        <MsalProvider instance={msalInstance}>
          <App />
        </MsalProvider>
      </React.StrictMode>
    );
  } catch (err) {
    console.error("Error al inicializar MSAL:", err);
  }
}

startApp();



/** 
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './context/AuthContext';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
*/